var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 356 356",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.774 238.66-10.167-10.167c-2.168-2.168-2.168-5.689 0-7.857s5.689-2.168 7.857 0l14.095 14.095a5.555 5.555 0 0 1 0 7.857l-19.758 19.757a5.554 5.554 0 0 1-7.856 0l-14.096-14.095a5.559 5.559 0 0 1 0-7.857 5.559 5.559 0 0 1 7.857 0l10.167 10.167z",
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.048 302.022c10.848-10.848 10.848-28.436 0-39.284L273.3 226.99a5.557 5.557 0 0 0-7.857 0l-35.239 35.24a5.555 5.555 0 0 0 0 7.857l35.748 35.748c10.848 10.848 28.436 10.848 39.283 0zm-39.676-63.247-27.383 27.383 31.82 31.82c6.508 6.509 17.061 6.509 23.57 0l3.812-3.813c6.509-6.508 6.509-17.061 0-23.57z",
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.389 32.38c-67.456 0-122.222 54.766-122.222 122.222 0 67.457 54.766 122.223 122.222 122.223s122.222-54.766 122.222-122.223c0-67.456-54.766-122.222-122.222-122.222zm0 11.111c61.324 0 111.111 49.787 111.111 111.111s-49.787 111.111-111.111 111.111S40.278 215.926 40.278 154.602 90.065 43.491 151.389 43.491z",
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.787 184.47c3.386-4.839 7.182-9.684 9.81-11.896 1.617-1.361 4.209-2.666 7.115-3.692 5.514-1.947 12.198-3.09 12.198-3.09a5.557 5.557 0 0 1 5.412 2.192s6.516 8.841 17.797 8.841c11.252 0 17.665-8.811 17.665-8.811a5.554 5.554 0 0 1 5.449-2.219s6.651 1.156 12.161 3.1c2.887 1.018 5.471 2.305 7.094 3.645 2.709 2.234 6.699 7.163 10.197 12.102a16.51 16.51 0 0 1 3.207 14.041 16.526 16.526 0 0 1-9.271 11.33c-11.174 5.045-28.516 11.256-45.497 11.256-17.19 0-35.318-6.383-46.932-11.403a16.59 16.59 0 0 1-6.405-25.396zm28.035-7.137a72.723 72.723 0 0 0-5.432 1.383c-2.199.661-4.452 1.361-5.638 2.359-2.159 1.817-5.169 5.91-7.946 9.883a5.126 5.126 0 0 1-.218.291 5.481 5.481 0 0 0-1.045 4.733 5.464 5.464 0 0 0 3.088 3.699c10.504 4.54 26.906 10.477 42.493 10.477 15.287 0 30.865-5.73 40.911-10.266a5.405 5.405 0 0 0 1.93-8.365 5.471 5.471 0 0 1-.256-.334c-2.874-4.069-6.061-8.242-8.293-10.083-1.21-.999-3.483-1.714-5.702-2.382a73.869 73.869 0 0 0-5.397-1.384c-3.877 3.935-12.211 10.592-24.198 10.592-12.001 0-20.402-6.682-24.297-10.603z",
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.015 126.886c-.118-3.625-.391-38.95 33.627-38.95 34.033 0 33.119 35.236 32.92 39.035-.054 11.623-6.648 23.135-14.785 30.444-5.894 5.294-12.599 8.298-18.135 8.298-5.5 0-12.3-2.986-18.325-8.247-8.4-7.334-15.277-18.914-15.302-30.58zm11.111-.061s-2.107-27.778 22.516-27.778c24.509 0 21.81 27.618 21.81 27.778 0 8.565-5.104 16.938-11.1 22.323-3.552 3.191-7.374 5.454-10.71 5.454-3.371 0-7.325-2.281-11.017-5.505-6.158-5.377-11.499-13.721-11.499-22.272z",
    fill: "#2b7f75",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancy);
export default __webpack_public_path__ + "static/media/Vacancy.d333cb4aebbbef01690191302a2bfcce.svg";
export { ForwardRef as ReactComponent };